import request from 'api/requestUtils'

export type TermsAndConditionsUpdateData = {
  orderId?: string,
  accepted?: boolean,
  acceptedAt?: string,
}

export function createTermsAndConditions(cartId: string, emailId: string) {
  return request.post('/api/carts/v1/terms-and-conditions', { cartId, emailId }, { credentials: 'include' })
}

export function updateTermsAndConditions(cartId: string, updateData: TermsAndConditionsUpdateData) {
  return request.patch(`/api/carts/v1/terms-and-conditions/${cartId}`, updateData, { credentials: 'include' })
}
